import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=154fc924&scoped=true&"
import script from "./Rooms.vue?vue&type=script&lang=js&"
export * from "./Rooms.vue?vue&type=script&lang=js&"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=154fc924&lang=scss&scoped=true&"
import style1 from "./Rooms.vue?vue&type=style&index=1&id=154fc924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fc924",
  null
  
)

export default component.exports